module.exports = __webpack_public_path__ + "static/advanced-security-boost-64212804c4c498c4c7f9cd0c6e9362a6.svg";